export enum TransferStatus {
  PENDING,
  SUCCEEDED,
  FAILED,
}

export namespace TransferStatus {
  let elements = [TransferStatus.PENDING, TransferStatus.SUCCEEDED, TransferStatus.FAILED];
  let alias = "com.bcdfx.model.TransferStatus";

  export function RemoteClass() {
    return alias;
  }

  export function getAllElements() {
    return elements;
  }
}
